export default class Attachment {
    constructor (dto) {
        this.id = 0
        this.documentId = 0
        this.user = ''
        this.description = ''
        this.date = ''
        this.fileId = ''
        this.fileName = ''
        this.canDisplay = true

        if (dto) {
            this.id = dto.Id
            this.documentId = dto.ObjectID
            this.user = dto.UserDisplayName
            this.description = dto.Description
            this.date = dto.CreationDate
            this.canDisplay = dto.CanDisplay
        }
    }

    toDto () {
        return {
            Id: this.id,
            ObjectID: this.documentId,
            Description: this.description,
            FileID: this.fileId,
            FileName: this.fileName,
        }
    }
}
